// if it is a public jam, isAuthed when jamUser in localStorage
// if it is a private jam, isAuthed when cookie present

import jamIsPublic from "./fetchApiHelpers/jamIsPublic"

export default async function isAuthenticated(
	JAM_ID: string,
): Promise<boolean> {
	const isPublic = await jamIsPublic(JAM_ID)

	if (isPublic) {
		const user = window.localStorage.getItem("jamUser")
		if (user) return true
		return false
	} else {
		if (
			document.cookie
				.split(";")
				.some((cookie) => cookie.trim().startsWith("jam_filled_cookie="))
		) {
			return true
		} else {
			return false
		}
	}
}
